import React, { Component } from 'react';
import { Field } from 'redux-form';
import { connect } from 'react-redux';

class TextArea extends Component {
    render = () => {
        const renderTextArea = ({input, meta: { touched, error, warning }}) => (
            <textarea {...input} placeholder={this.props.placeholder} rows="10" cols="40" className="text-area" />
        );
        
        return <Field name={this.props.name} component={renderTextArea} />;
    };
}

export default connect()(TextArea);



// WEBPACK FOOTER //
// ./src/components/shared/form/TextArea.js